import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountCtaHeroBanner() {
	const ctaHeroBanner = document.getElementById('cta-hero-banner');

	if (!ctaHeroBanner) {
		console.warn('[CtaHeroBanner] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'CtaHeroBannerApp',
	});
	app.component(
		'cta-hero-banner',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "cta-hero-banner" */ 'shared/components/ctaHeroBanner.vue'
				),
		),
	);
	app.component(
		'send-campaign-id-cta-button',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/SendCampaignIdCtaButton.vue'),
		),
	);
	app.component(
		'cta-button-with-popup-form',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
		),
	);
	app.component(
		'form-kit-builder-container',
		defineAsyncComponent(
			() =>
				import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(ctaHeroBanner);
}

mountCtaHeroBanner().catch((error) => {
	console.error('Error mounting cta hero banner:', error);
});

